
export const modality = {
  cr: { label: 'Computed Radiography (CR)', value: 'CR' },
  ct: {label:  'Computed Tomography (CT)', value: 'CT' },
  dx: { label:  'Digital Radiography (DX)', value: 'DX' },
  ecg: { label:  'Electrocardiography (ECG)', value: 'ECG' },
  mr: { label:  'Magnetic Resonance (MR)', value: 'MR' },
  mg: {label:  'Mammography (MG)', value: 'MG' },
  nm: { label:  'Nuclear Medicine (NM)', value: 'NM' },
  op: { label:  'Ophthalmic Photography (OP)', value: 'OP' },
  ot: { label:  'Other (OT)', value: 'OT' },
  pt: { label:  'Positron emission tomography (PET)', value: 'PET' },
  rf: { label:  'Radio Fluoroscopy (RF)', value: 'RF' },
  xa: { label:  'X-Ray Angiography (XA)', value: 'XA' },
  us: { label:  'Ultrasound (US)', value: 'US' }
}
//   bi: { label: 'Biomagnetic imaging', value: 'BI' },
//   dg: { label: 'Diaphanography', value: 'DG' },
//   es: { label: 'Endoscopy', value: 'ES' },
//   ls: { label: 'Laser surface scan', value: 'LS' },
//   rg: { label: 'Radiographic imaging conventional film/screen)', value: 'RG' },
//   tg: { label: 'Thermography', value: 'TG' },
//   rtimage: { label: 'Radiotherapy Image', value: 'RTIMAGE' },
//   rtdose: { label: 'Radiotherapy Dose', value: 'RTDOSE' },
//   restruct: { label: 'Radiotherapy Structure Set', value: 'RTSTRUCT' },
//   rtplan: { label: 'Radiotherapy Plan', value: 'RTPLAN' },
//   rtrecord: { label: 'RT Treatment Record', value: 'RTRECORD' },
//   hc: { label: 'Hard Copy', value: 'HC' },
//   io: { label: 'Intra-oral Radiography', value: 'IO' },
//   px: { label: 'Panoramic X-Ray', value: 'PX' },
//   gm: { label: 'General Microscopy', value: 'GM' },
//   sm: { label: 'Slide Microscopy', value: 'SM' },
//   xc: { label: 'External-camera Photography', value: 'XC' },
//   pr: { label: 'Presentation State', value: 'PR' },
//   au: { label: 'Audio', value: 'AU' },
//   eps: { label: 'Cardiac Electrophysiology', value: 'EPS' },
//   hd: { label: 'Hemodynamic Waveform', value: 'HD' },
//   sr: { label: 'SR Document', value: 'SR' },
//   ivus: { label: 'Intravascular Ultrasound', value: 'IVUS' },
//   smr: { label: 'Stereometric Relationship', value: 'SMR' },
//   ar: { label: 'Autorefraction', value: 'AR' },
//   ker: { label: 'Keratometry', value: 'KER' },
//   va: { label: 'Visual Acuity', value: 'VA' },
//   srf: { label: 'Subjective Refraction', value: 'SRF' },
//   oct: { label: 'Optical Coherence Tomography (non-Ophthalmic)', value: 'OCT' },
//   len: { label: 'Lensometry', value: 'LEN' },
//   opv: { label: 'Ophthalmic Visual Field', value: 'OPV' },
//   opm: { label: 'Ophthalmic Mapping', value: 'OPM' },
//   oam: { label: 'Ophthalmic Axial Measurements', value: 'OAM' },
//   resp: { label: 'Respiratory Waveform', value: 'RESP' },
//   ko: { label: 'Key Object Selection', value: 'KO' },
//   seg: { label: 'Segmentation', value: 'SEG' },
//   reg: { label: 'Registration', value: 'REG' },
//   opt: { label: 'Ophthalmic Tomography', value: 'OPT' },
//   bdus: { label: 'Bone Densitometry (ultrasound)', value: 'BDUS' },
//   bmd: { label: 'Bone Densitometry (X-Ray)Bone Densitometry (ultrasound)', value: 'BMD' },
//   doc: { label: 'Document', value: 'DOC' },
//   fid: { label: 'Fiducials', value: 'FID' },
//   plan: { label: 'Plan', value: 'PLAN' },
//   iol: { label: 'Intraocular Lens Data', value: 'IOL' },
//   ivoct: { label: 'Intravascular Optical Coherence Tomography', value: 'IVOCT' }
// }
